import PropTypes from 'prop-types'

import { positionPropType } from '../common/position-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'

/**
 * @typedef {Object} CameraEvent
 * @property {string} [eventId] - Id of the event.
 * @property {string} [cameraId] - The ID of the camera (a.k.a IMEI).
 * @property {number} [gForce] - The g-force at which the event occurred in g.
 * @property {Position} [location] - location of the event.
 * @property {string} [objectId] - The object ID associated during the event time.
 * @property {number} [roadSpeedLimit] - The speed limit in meters per second of the road where the event happened.
 * @property {number} [severity] - unknown measure of severity.
 * @property {number} [speed] - The speed in meters per second at which the event occurred.
 * @property {iso8601DateTimeSting} [time] - The time when the event happened in ISO8601 UTC format.
 * @property {string} [type] - type of the event, can be one of DRIVER_DISTRACTED, DRIVER_DROWSY, DRIVER_EATING,
 *      DRIVER_MOBILE_PHONE, DRIVER_SEATBELT, DRIVER_SMOKING, DRIVING_CRASH, DRIVING_HARSH_TURN_LEFT,
 *      DRIVING_HARSH_TURN_RIGHT, DRIVING_HARSH_BRAKING, REQUESTED_SOS, REQUESTED_VIDEO, DRIVING_TAILGATING, DRIVER_CAMERA_COVERED, EXTERNAL_INPUT, EXTERNAL_OUTPUT, DRIVING_LANE_WEAVING
 * @property {string} [videoAvailability] - Status of event-videos, one of AVAILABLE, PENDING, UNAVAILABLE
 */
export const cameraEventPropType = PropTypes.shape({
    cameraId: PropTypes.string,
    eventId: PropTypes.string,
    gForce: PropTypes.number,
    location: PropTypes.shape({
        locationDescription: locationDescriptionPropType,
        position: positionPropType
    }),
    objectId: PropTypes.string,
    roadSpeedLimit: PropTypes.number,
    severity: PropTypes.number,
    speed: PropTypes.number,
    thumbnails: PropTypes.arrayOf(
        PropTypes.shape({
            cameraViewId: PropTypes.string,
            url: PropTypes.string
        })
    ),
    time: iso8601PropType,
    type: PropTypes.oneOf([
        'DRIVER_DISTRACTED',
        'DRIVER_DROWSY',
        'DRIVER_EATING',
        'DRIVER_MOBILE_PHONE',
        'DRIVER_SEATBELT',
        'DRIVER_SMOKING',
        'DRIVING_CRASH',
        'DRIVING_HARSH_TURN_LEFT',
        'DRIVING_HARSH_TURN_RIGHT',
        'DRIVING_HARSH_BRAKING',
        'REQUESTED_SOS',
        'REQUESTED_VIDEO',
        'DRIVING_TAILGATING',
        'DRIVER_CAMERA_COVERED',
        'EXTERNAL_INPUT',
        'EXTERNAL_OUTPUT',
        'DRIVING_LANE_WEAVING'
    ]),
    videoAvailability: PropTypes.oneOf(['AVAILABLE', 'PENDING', 'UNAVAILABLE', 'REQUESTABLE', 'REQUESTED'])
})
